import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';

const initialState = fromJS({
    isLoading: false,
    isAuthorized: false,
    user: {
        data: null
    },
    editModal: {
        isShown: false,
        isLoading: false,
        record: null
    },
    changePasswordModal: {
        isShown: false,
        isLoading: false,
        hasError: false,
        errorText: null
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case CONSTANTS.ON_AUTH_CHANGE_PASSWORD_ERROR:
            return state
                    .setIn(['changePasswordModal','hasError'], payload.hasError)
                    .setIn(['changePasswordModal','errorText'], payload.errorText);

        case CONSTANTS.ON_AUTH_CHANGE_PASSWORD_IS_LOADING:
            return state.setIn(['changePasswordModal', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_AUTH_CHANGE_PASSWORD_IS_SHOWN:
            return state.setIn(['changePasswordModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_AUTH_IS_LOADING:
            return state.set('isLoading', payload.isLoading);

        case CONSTANTS.ON_AUTH_IS_AUTHORIZED:
            return state.set('isAuthorized', payload.isAuthorized);

        case CONSTANTS.ON_AUTH_TOKEN:
            return state.setIn(['user', 'token'], payload.token);

        case CONSTANTS.ON_AUTH_USER:
            return state
                .setIn(['user', 'data'], payload.userData)
                .setIn(['user', 'keycloakData'], payload.keycloakUserData);

        case CONSTANTS.ON_AUTH_EDIT_MODAL_IS_SHOWN:
            return state.setIn(['editModal', 'isShown'], payload.isShown);

        case CONSTANTS.ON_AUTH_EDIT_MODAL_IS_LOADING:
            return state.setIn(['editModal', 'isLoading'], payload.isLoading);
        default:
            return state;
    }
};

export default reducer;
